import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import Logo from "@/components/Logo";
import { NAV, CONTACT } from "@/data/site";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-ink/90 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="container-x flex items-center justify-between h-[76px]">
        <Logo variant="dark" />

        <nav className="hidden lg:flex items-center gap-4 xl:gap-6">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`nav-${item.to === "/" ? "home" : item.to.replace("/", "")}`}
              className={({ isActive }) =>
                `text-sm font-semibold whitespace-nowrap transition-colors duration-200 ${
                  isActive ? "text-aqua" : "text-white/80 hover:text-white"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href={`tel:${CONTACT.phoneTel}`}
            data-testid="header-call-btn"
            className="hidden xl:inline-flex items-center gap-2 text-sm font-semibold text-white/90 hover:text-aqua transition-colors whitespace-nowrap"
          >
            <Phone size={16} strokeWidth={2} />
            {CONTACT.phoneDisplay}
          </a>
          <Link to="/contact" data-testid="header-devis-btn" className="btn-cta whitespace-nowrap">
            Devis gratuit
          </Link>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden text-white p-2"
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-ink border-t border-white/10 px-5 py-6 space-y-1">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `block py-2.5 text-base font-semibold ${isActive ? "text-aqua" : "text-white/85"}`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <div className="pt-4 flex flex-col gap-3">
            <a href={`tel:${CONTACT.phoneTel}`} className="btn-ghost">
              <Phone size={16} /> {CONTACT.phoneDisplay}
            </a>
            <Link to="/contact" className="btn-cta">Devis gratuit</Link>
          </div>
        </div>
      )}
    </header>
  );
}
